// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-layout-item {
  position: absolute;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

:where(.vuetify-styles) .v-layout-item--absolute {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VLayout/VLayoutItem.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".v-layout-item {\n  position: absolute;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.v-layout-item--absolute {\n  position: absolute;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
